module.exports = __webpack_public_path__ + "img/Thumbnails_Manufacturing.fe7ef6f3.jpg";